import { useEffect, useState } from 'react';
import { Pause, Music2 } from 'lucide-react';
import { useAudio } from '../../context/AudioContext';

const Playlist = () => {
  const [imageError, setImageError] = useState({});
  const {
    isPlaying,
    currentTrack,
    musicList,
    handleTrackSelect,
    trackDurations,
    probeTrackDuration,
    formatTime,
  } = useAudio();

  useEffect(() => {
    musicList.forEach(probeTrackDuration);
  }, [musicList, probeTrackDuration]);

  return (
    <div>
      <h2 className="text-2xl font-bold text-lz-ink-mid dark:text-lz-concrete mb-8">Playlist</h2>
      <div className="space-y-1 pb-4">
        {musicList.map((track, index) => {
          const isCurrent = currentTrack?.id === track.id;
          return (
            <div
              key={track.id || index}
              onClick={() => handleTrackSelect(track)}
              className={`flex items-center justify-between p-3 rounded-lg hover:bg-lz-concrete dark:hover:bg-lz-ink-mid/60 transition-colors cursor-pointer ${isCurrent ? 'bg-lz-concrete dark:bg-lz-ink-mid' : ''
                }`}
            >
              <div className="flex items-center gap-4">
                <div className="relative">
                  {track.artistImage && !imageError[track.id] ? (
                    <img
                      src={track.artistImage}
                      alt={`${track.trackName} cover`}
                      className="w-12 h-12 md:w-16 md:h-16 rounded-lg object-cover shadow-lg"
                      crossOrigin="anonymous"
                      onError={() => setImageError(prev => ({ ...prev, [track.id]: true }))}
                    />
                  ) : (
                    <div className="w-12 h-12 md:w-16 md:h-16 rounded-lg bg-lz-concrete dark:bg-lz-ink-mid flex items-center justify-center shadow-lg">
                      <Music2 size={28} className="text-lz-ink-mid dark:text-lz-candle-dim" />
                    </div>
                  )}
                  {isCurrent && isPlaying && (
                    <div className="absolute inset-0 bg-black/40 rounded-lg flex items-center justify-center">
                      <Pause size={24} className="text-white" />
                    </div>
                  )}
                </div>
                <div>
                  <div className="font-medium text-base md:text-lg text-black dark:text-lz-concrete">
                    {track.trackName}
                  </div>
                  <div className="text-sm text-lz-ink-mid dark:text-lz-concrete mt-1">
                    {track.artist} • {track.album}
                  </div>
                </div>
              </div>
              <div className="text-sm text-lz-ink-mid dark:text-lz-candle-bright tabular-nums">
                {trackDurations[track.id] != null ? formatTime(trackDurations[track.id]) : '--:--'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Playlist;
